module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C920"
  }, [_c('span', {
    attrs: {
      "id": "id_8"
    }
  }, [_vm._v("CONTENTS ")])]), _vm._v(" "), _c('p', {
    staticClass: "C924"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/html/08_Acknowle#id_9"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "C925"
  }, [_c('a', {
    attrs: {
      "href": "#/html/09_Introduc#page_1"
    }
  }, [_vm._v("Introduction: Bad Ideas")])]), _vm._v(" "), _c('p', {
    staticClass: "C926"
  }, [_c('a', {
    attrs: {
      "href": "#/html/10_1_The_Gr#page_19"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("1")]), _vm._v("The Grand Collision of Spring 1950")])]), _vm._v(" "), _c('p', {
    staticClass: "C926"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_2_A_Mono#page_49",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("2")]), _vm._v("A Monolithic Oneness")])]), _vm._v(" "), _c('p', {
    staticClass: "C926"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_3_The_Ba#page_79",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("3")]), _vm._v("The Battle over Lysenkoism")])]), _vm._v(" "), _c('p', {
    staticClass: "C926"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_4_Experi#page_106",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("4")]), _vm._v("Experiments in Rehabilitation")])]), _vm._v(" "), _c('p', {
    staticClass: "C926"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_5_Skirmi#page_135",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("5")]), _vm._v("Skirmishes on the Edge of Creation")])]), _vm._v(" "), _c('p', {
    staticClass: "C926"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_6_Strang#page_163",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("6")]), _vm._v("Strangest Bedfellows")])]), _vm._v(" "), _c('p', {
    staticClass: "C927"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_Conclusi#page_195",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: Pseudoscience in Our Time")])]), _vm._v(" "), _c('p', {
    staticClass: "C925"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/17_Abbrevia#page_213",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Abbreviations and Archives")])])]), _vm._v(" "), _c('p', {
    staticClass: "C927"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/18_Notes#page_215",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "C927"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/19_Index#page_281",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-192f7363","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/07_Contents.vue
// module id = 72
// module chunks = 0